export default String.raw`
.categories-map{
    &__categories{
        column-gap: 0;
    }
    .category{
        width: calc(100%/3);
        padding: 25px 15px;
        &__name{
            margin-top: 15px;
        }
    }
}
`